import type { InboxEntry, InboxEntryKind } from '@/types/inbox'

const POST_KINDS: ReadonlySet<InboxEntryKind> = new Set([
  'post.draft',
  'post.publishFailed',
  'post.published',
  'post.results',
])

export type PostEntry = Extract<
  InboxEntry,
  { kind: 'post.draft' | 'post.publishFailed' | 'post.published' | 'post.results' }
>

/** Whether a message is about a post. */
export function isPostEntry(entry: InboxEntry): entry is PostEntry {
  return POST_KINDS.has(entry.kind)
}

/** The kind as a message-key segment: `post.publishFailed` becomes `postPublishFailed`. */
export function kindKey(kind: InboxEntryKind): string {
  return kind.replace(/\.(\w)/, (_, letter: string) => letter.toUpperCase())
}
